// ASSET //
const asset = (schema) => {
  if (schema.type === 'string' && _.get(schema.options, 'assetType')) {
    return 'asset'
  }
}

// DATASET //
const dataset = (schema) => {
  if (schema.type === 'string' && _.get(schema.options, 'source') === 'datasets') {
    return 'dataset'
  }
}

// LARGE ARRAY //
const largeArray = (schema) => {
  if (schema.type === 'array' && _.get(schema.options, 'large') === true) {
    return 'largeArray'
  }
}

// TAGS //
const tags = (schema) => {
  if (schema.type === 'array' && _.get(schema.options, 'tags') === true) {
    return 'tags'
  }
}

// EnumSourceHelper //
const enumSourceHelper = (schema) => {
  if (schema.type === 'enumSourceHelper') {
    return 'enumSourceHelper'
  }
}

// NestedArrayEnumSourceHelper //
const nestedArrayEnumSourceHelper = (schema) => {
  if (schema.type === 'nestedArrayEnumSourceHelper') {
    return 'nestedArrayEnumSourceHelper'
  }
}

// CSV Array Resolver //
const csvArray = (schema) => {
  if (schema.type === 'csvArray') {
    return 'csvArray'
  }
}

// Header Resolver //
const header = (schema) => {
  if (schema.type === 'header') {
    return 'header'
  }
}

// Type Selector //
const typeSelector = (schema) => {
  if (schema.type === 'type-selector') {
    return 'typeSelector'
  }
}

export default [asset, dataset, largeArray, tags, enumSourceHelper, nestedArrayEnumSourceHelper, csvArray, header, typeSelector]
